import "./Devsphire.module.css";

const DevsphireHeroSection = () => {
  return (
    <div className="container bg-white rounded py-5 my-5 text-center">
      <h2 className="text-capitalize text-success mb-3">DevSphire</h2>
      <p
        style={{
          wordSpacing: "1px",
        }}
      >
        DevSphire was born from the shared passion of two childhood friends with
        a deep interest in technology. From their school days, they were
        immersed in exploring and learning about tech, dedicating their time to
        mastering it. Starting with rooting devices and flashing custom or stock
        ROMs, they’ve grown together, advancing their skills to now developing
        cutting-edge web applications. Their journey in technology continues to
        evolve as they climb new heights. DevSphire is a comprehensive platform
        that enables anyone to connect, submit their requests, and receive best
        digital web solutions for their products or services. We offer services
        such as full-stack web development to create impactful webpages that
        help grow your business and enhance its market presence.
      </p>
    </div>
  );
};

export default DevsphireHeroSection;
